import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pt_1",
  "use": "icon-pt_1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pt_1\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M15,16h2v2H15ZM4,2H20a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V3A1,1,0,0,1,4,2ZM5,13V20H19V4H14A10,10,0,0,1,5,13Zm0-2A8,8,0,0,0,11.94,4H5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol